module.exports = __webpack_public_path__ + "static/softball-clubhouse-makeover-ecea57e00c04dda26ac5b0999b19b8a3.jpg";